
<template>
    <div>
      <input
        v-if="searchSupported()"
        ref="inputSearch"
        v-model="searchTerm"
        type="text"
        class="form-control"
        placeholder="email o nom cognom"
      />
      <div v-else class="notification is-light mt-4">
        Directory search not supported for personal accounts, sorry!
      </div>
      <br>
      <div v-if="error" class="notification is-danger mt-4">⚠ {{ error }}</div>
      <div v-if="users" class="table-responsive-sm">
        <table class="table table-sm table-hover">
          <thead class="table-primary">
            <tr>
              <!-- <th>Display Name</th> -->
              <th>Noms</th>
              <th>Email</th>
              <!-- <th>uuid_id</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="userResult of empleats" :key="userResult.id" @click="empleatSeleccionat(userResult)">
              <!-- <td>{{ userResult.displayName }}</td> -->
              <td>{{ userResult.givenName }} {{ userResult.surname }}</td>
              <td>{{ userResult.mail }}</td>
              <!-- <td>{{ userResult.id }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  import _ from 'lodash'
  import graph from '@/services/graph'
  
  export default {
    name: 'CercaEmpleat',
  
    props: {
      user: {
        type: Object,
        required: true,
        default () {return {}}
      },
      accessToken: {
        type: String,
        required: true,
        default: ''
      },
    },
  
    data() {
      return {
        users: null,
        searchTerm: null,
        error: null,
        clicks: 0,
        empleat: null
      }
    },




    computed: {
      empleats() {
        if (!this.searchTerm) {return null}
        if (this.searchTerm.trim().length==0) {return null}
        return this.users
      }
    },
    watch: {
      // Watch the search field and run a Graph search with a debounce
      searchTerm(newValue) {
        if (newValue.trim().length>0) {
          this.searchDebounce(newValue)
        }else{
          this.users=null
        }
      }
    },
    mounted() {
      
    },
    methods: {

      empleatSeleccionat(empleat) {
        this.clicks++
        if (this.clicks === 1) {
          this.empleat=empleat
          setTimeout( () => {
                this.empleat=null
                this.clicks = 0
              }, 500);
        } else {
          if (empleat==this.empleat) {
            //console.log(empleat.displayName)
            this.$emit('close',empleat)
          }
        }
      },
      inputFocus() {
        
        // const inputSearch = this.$refs.inputSearch;
        // inputSearch.focus();
        //this.$refs.inputSearch.focus()
        //console.log(this.$refs.inputSearch)
        this.$nextTick(() => {
          this.$refs.inputSearch.focus();
        });
      },
      searchSupported() {
        if (!this.user || !this.user.idTokenClaims) {
          return false
        }
        return this.user.idTokenClaims.tid !== '9188040d-6c67-4c5b-b112-36a304b66dad'
      },
  
      // Lodash debounce wrapper around the HTTP call to the Graph
      searchDebounce: _.debounce(async function(searchString) {
        if (!this.accessToken) {
          return
        }
        try {
          let searchRes = await graph.searchUsers(searchString, 20)
          // console.log(searchRes.value)
          this.users = searchRes.value
        } catch (err) {
          this.error = err.toString()
        }
      }, 300)
    }
  }
  </script>
  